import CampusBlock from "../common/blocks/CampusBlock";
const Campus = () => {
	return (
	<CampusBlock />		
	);
};
export default Campus;